import { isPresent } from 'utils'
import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'

const NullableNumber = ({
  value,
  decimalScale,
  prefix,
  suffix,
  thousandSeparator = true,
  alternative = '-',
  fixedDecimalScale,
}) =>
  !isPresent(value) || isNaN(value) ? (
    alternative
  ) : (
    <NumberFormat
      value={value}
      displayType="text"
      thousandSeparator={thousandSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      prefix={prefix}
      suffix={suffix}
    />
  )

NullableNumber.propTypes = {
  alternative: PropTypes.node,
  decimalScale: PropTypes.number,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  thousandSeparator: PropTypes.bool,
  fixedDecimalScale: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
export default NullableNumber
